import { makeStyles } from "@mui/styles";
const useLandingPageLoginSignupStyles = makeStyles(() => {
  return {
    loginTrialContainer: {
      background: "none",
      width: "-webkit-fill-available",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexDirection: "row",
      "&.mobile": {
        margin: "5px 0px 10px 10px !important",
        flexDirection: "column !important",
      },
    },

    loginOuterContainer: {
      display: "flex",
      flexDirection: "column",
      "&.mobile": {
        width: "100% !important",
      },
    },

    form: {
      display: "flex",
      flexDirection: "row",
      "&.mobile": {
        flexDirection: "column  !important",
        paddingTop: "30px !important",
        width: "100% !important",
      },
    },

    buttonsHolder: {
      display: "flex",
      height: "40px",

      "&.mobile": {
        marginBottom: "10px  !important",
        marginTop: "10px  !important",
        justifyContent: "center",
        marginRight: "6px",
      },
    },

    forgotPasswordOuterContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },

    forgotPassword: {
      fontSize: "16px",
      fontWeight: "400",
      fontFamily: "Lato",
      color: "white",
    },

    email: {
      background: "#FFFFFF ",
      minWidth: "250px !important",
      "&.mobile": {
        width: "100% !important",
      },
    },

    emailPlaceHolder: {},

    loginBtn: {
      margin: "0 10px !important",
      "&.mobile": {
        margin: "0px 10px 0px 0px !important",
        width: "100% !important",
      },
    },

    signUpBtn: {
      "&.mobile": {
        margin: "0px 10px 0px 0px !important",
        width: "100% !important",
      },
    },
  };
});

export default useLandingPageLoginSignupStyles;
